// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__ZnyJs","header":"PatientQuestionnaire_header__KS70F","info":"PatientQuestionnaire_info__3rqMI"};